export default __webpack_public_path__ + "images/6_2_image.jpg";